import { render, staticRenderFns } from "./DeliveryMethodInstanceDialog.vue?vue&type=template&id=b3e4fdbe"
import script from "./DeliveryMethodInstanceDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodInstanceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports